import * as React from 'react';
import classnames from 'classnames';
import type { FabProps } from '@mui/material';
import { Fab, useTheme } from '@mui/material';

import { makeStyles } from 'tss-react/mui';
import { type ITheme } from '../../theme';

const useStyles = makeStyles()(() => ({
  withoutBoxShadow: {
    boxShadow: 'none',
  },
}));

export interface GradientFabProps extends FabProps {
  gradient?: 'primary' | 'secondary';
  flat?: boolean;
  disabledProp?: boolean;
  target?: string;
}

const GradientFab: React.FC<GradientFabProps> = ({
  gradient = 'primary',
  color = 'primary',
  flat = true,
  disabledProp,
  children,
  ...props
}) => {
  const theme: ITheme = useTheme();
  const { classes } = useStyles();
  let newColor = color;
  let useGradient = theme.gradients.primaryGradient;
  if (gradient === 'secondary') {
    useGradient = theme.gradients.secondaryGradient;
    newColor = 'secondary';
  }

  return (
    <Fab
      style={{ backgroundImage: disabledProp ? useGradient : '' }}
      className={classnames(flat && classes.withoutBoxShadow)}
      color={newColor}
      disabled={disabledProp}
      variant="extended"
      {...props}
    >
      {children}
    </Fab>
  );
};

export default GradientFab;
